<template>
  <validation-provider
    ref="lenonDate"
    :vid="name"
    :name="formatName(name)"
    :rules="rules"
  >
    <b-form-group>
      <label
        v-if="label && showLabel"
        :for="`date-${name}`"
      ><span v-html="$t(label)" /> <b
        v-if="isRequired"
        class="text-danger"
        style="font-size: 15px"
      >*</b></label>
      <!--      <b-input-group>-->
      <flat-pickr
        :id="`date-${name}`"
        :name="name"
        class="form-control"
        :placeholder="label"
        :config="monthSelectConfig"
        :value="value"
        mode="range"
        @input="inputChanged"
      />
      <!--        <b-input-group-append-->
      <!--          is-text-->
      <!--        >-->
      <!--          <feather-icon-->
      <!--            class="cursor-pointer"-->
      <!--            icon="CalendarIcon"-->
      <!--          />-->
      <!--        </b-input-group-append>-->

      <!--      </b-input-group>-->
      <small
        v-if="showError"
        class="text-danger text-capitalize"
      >{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import {
  BFormGroup,
} from 'bootstrap-vue'
/* eslint-disable global-require */
import { ValidationProvider } from 'vee-validate'
import { required, noFutureDate, noPastDate } from '@core/utils/validations/validations'

export default {
  name: 'LenonMonthYearPicker',
  components: {
    BFormGroup,
    ValidationProvider,
    flatPickr,
  },
  props: {
    name: {
      type: String,
      default: 'date',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    rules: {
      type: String,
      default: '',
    },
    showError: { type: Boolean, default: true },
    enableTime: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true },
  },
  data() {
    return {
      required,
      noFutureDate,
      noPastDate,
      errors: [],
      monthSelectConfig: {
        altFormat: 'F Y',
        altInput: true,
        disableMobile: 'true',
        plugins: [
          new monthSelectPlugin({
            shorthand: true,
            dateFormat: 'Y-m',
          }),
        ],
      },
    }
  },
  computed: {
    isRequired() {
      return this.rules.includes('required')
    },
  },
  watch: {
    value(val) {
      // this.$refs.lenonDate.validate().then(res => {
      //   this.errors = res.errors
      // })
    },
  },
  methods: {
    formatName(name) {
      return name.replaceAll('_', ' ')
    },
    inputChanged(e) {
      this.$emit('input', e)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.flatpickr-monthSelect-month.selected{
  background-color: #fa2;
}
.flatpickr-monthSelect-theme-dark .flatpickr-monthSelect-month.selected{
  border-color: #ffc259;
}
</style>
